import { post } from './index'
import config from '@/config'
import axios from 'axios'

// 自定义 JSON 解析器，避免长数字精度丢失（参考小程序 Taro 实现）
function safeJsonParse({ text, convertFieldName = 'articleId' }) {
  if (typeof text !== 'string') return text

  // 先把指定字段的数字替换成字符串形式，避免被当成 Number 解析
  const regex = new RegExp(`("${convertFieldName}":)(\\d{0,})(,)`, 'g')
  const processedText = text.replace(regex, '$1"' + '$2' + '"$3')

  // 使用 reviver 再兜底一次：如果还是解析成 number，就转成字符串
  return JSON.parse(processedText, (key, value) => {
    if (key === convertFieldName && typeof value === 'number') {
      return String(value)
    }
    return value
  })
}

// 获取活动详情
export function marketingDetail(params) {
  return post('/marketing-campaign/detail', params)
}

export function bindVip(params) {
  return post(`/bind-vip`, params)
}

export function getFlashSaleData(params) {
  return post('/seckill/current-rounds', params)
}
// 查询定制活动页 v2
export function getCustomRecommendProductListV2(params) {
  return axios(
    {
      url: '/openapi/custom-recommend-product/list/v2',
      baseURL: config.domainName,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        loginToken: sessionStorage.getItem('loginToken'),
      }, // 头部信息处理
      // 关键：拿到原始字符串，不让 axios 自动 JSON.parse（否则会直接丢精度）
      responseType: 'text',
      transformResponse: [
        function (data) {
          // 直接返回原始字符串，后面手动解析
          return data
        },
      ],
    },
    {
      prefix: config.mobServer,
    }
  ).then(res => {
    const raw = res.data

    try {
      // 如果后端长数字字段名不是 articleId，请在这里改为真实字段名，例如 productId
      const parsed = safeJsonParse({
        text: raw,
        convertFieldName: 'articleId',
      })
      res.data = parsed
    } catch (e) {
      // 自定义解析失败则兜底：尝试普通 JSON.parse
      try {
        res.data = JSON.parse(raw)
      } catch (e2) {
        // 再兜底：直接回传字符串
        res.data = raw
      }
    }

    return res
  })
}

// 查询定制活动页（处理后端返回的长数字不失真）
export function getCustomRecommendProductList(params) {
  return axios(
    {
      url: '/openapi/custom-recommend-product/list',
      baseURL: config.domainName,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        loginToken: sessionStorage.getItem('loginToken'),
      }, // 头部信息处理
      // 关键：拿到原始字符串，不让 axios 自动 JSON.parse（否则会直接丢精度）
      responseType: 'text',
      transformResponse: [
        function (data) {
          // 直接返回原始字符串，后面手动解析
          return data
        },
      ],
    },
    {
      prefix: config.mobServer,
    }
  ).then(res => {
    const raw = res.data

    try {
      // 如果后端长数字字段名不是 articleId，请在这里改为真实字段名，例如 productId
      const parsed = safeJsonParse({
        text: raw,
        convertFieldName: 'articleId',
      })
      res.data = parsed
    } catch (e) {
      // 自定义解析失败则兜底：尝试普通 JSON.parse
      try {
        res.data = JSON.parse(raw)
      } catch (e2) {
        // 再兜底：直接回传字符串
        res.data = raw
      }
    }

    return res
  })
}
